import React, { useState } from 'react';
import { MoveHorizontalIcon } from 'lucide-react';
interface BeforeAfterProps {
  before: string;
  after: string;
  beforeLabel: string;
  afterLabel: string;
  hint: string;
  alt: string;
}
export function BeforeAfter({
  before,
  after,
  beforeLabel,
  afterLabel,
  hint,
  alt
}: BeforeAfterProps) {
  const [position, setPosition] = useState(52);
  return <div className="group relative aspect-[3/2] w-full select-none overflow-hidden rounded bg-ink" data-id="element-17" data-mp="3epydg5wl3m2v">
      <img src={after} alt={`${alt} — ${afterLabel}`} className="absolute inset-0 h-full w-full object-cover" loading="lazy" data-id="element-18" data-mp="3jgojllcu3sym" />
      <div className="absolute inset-y-0 left-0 overflow-hidden" style={{
      width: `${position}%`
    }} aria-hidden="true" data-id="element-19" data-mp="34sjxs8ihj1bm">
        <img src={before} alt="" className="h-full w-full object-cover" style={{
        width: `${100 / Math.max(position, 1) * 100}%`,
        maxWidth: 'none'
      }} loading="lazy" data-id="element-20" data-mp="39osehqcbz2kw" />
      </div>

      <span className="pointer-events-none absolute inset-y-0 w-0.5 bg-brand-500" style={{
      left: `${position}%`
    }} aria-hidden="true" data-id="element-21" data-mp="x40t84oo0c2t">
        <span className="absolute left-1/2 top-1/2 flex h-10 w-10 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-brand-500 shadow-lift" data-id="element-22" data-mp="t5b7noth3o83">
          <MoveHorizontalIcon className="h-5 w-5 text-ink" data-id="element-23" data-mp="1246ff5c616di" />
        </span>
      </span>

      <span className="pointer-events-none absolute left-3 top-3 rounded bg-ink/85 px-2.5 py-1 text-[11px] font-bold uppercase tracking-wider text-white" data-id="element-24" data-mp="eeubokzlxqil">
        {beforeLabel}
      </span>
      <span className="pointer-events-none absolute right-3 top-3 rounded bg-brand-500 px-2.5 py-1 text-[11px] font-bold uppercase tracking-wider text-ink" data-id="element-25" data-mp="o4xa50phzwob">
        {afterLabel}
      </span>
      <span className="pointer-events-none absolute inset-x-0 bottom-3 text-center text-[11px] font-semibold uppercase tracking-wider text-white/80 opacity-100 transition-opacity duration-200 ease-smooth group-hover:opacity-0" data-id="element-26" data-mp="3rs76u0ujtgs4">
        {hint}
      </span>

      <input type="range" min={0} max={100} value={position} onChange={event => setPosition(Number(event.target.value))} aria-label={`${alt}: ${hint}`} className="compare-slider absolute inset-0 h-full w-full cursor-ew-resize opacity-0" data-id="element-27" data-mp="1qowr9f0dnw4r" />
    </div>;
}